module.exports = __webpack_public_path__ + "img/public/SiteIcons/editingWishIcon.svg?cded0f30";